export default "__VITE_ASSET__BXk2v0UC__"